import React, { useState, useMemo } from "react";
import { useWallet } from "../../context/walletContext";
import { MdClose } from "react-icons/md";
import { useNotify } from "../../context/NotifyContext";
import { formatAmount } from "../../utils/formatAmount";

const ServicesForm = ({ bill, onSubmit, loading, close }) => {
  const {notify} = useNotify();
  const { walletAmt } = useWallet();

  /* 💰 Wallet balance */
  const walletBalance = useMemo(
    () => Number(walletAmt?.main?.balance || 0),
    [walletAmt]
  );

  /* 🧾 Bill amount (safe fallback) */
  const billAmount = useMemo(
    () =>
      Number(
        bill?.bill_fetch?.billAmount ??
          bill?.amount ??
          0
      ),
    [bill]
  );

  const [amount, setAmount] = useState(billAmount);

  /* 💳 Pay click */
  const handlePayClick = () => {
    if (loading) return;

    const finalAmount = Number(amount);

    if (!Number.isFinite(finalAmount) || finalAmount <= 0) {
      notify("Enter a valid amount", "error");
      return;
    }

    if (finalAmount > billAmount) {
      notify(`Amount cannot exceed bill amount ₹${billAmount}`, "error");
      return;
    }

    if (finalAmount > walletBalance) {
      notify(`Insufficient wallet balance ₹${walletBalance}`, "error");
      return;
    }

    onSubmit({ amount: finalAmount,bill_fetch:bill?.bill_fetch });
  };

  /* 🔢 Input guard */
  const handleInputChange = (e) => {
    const val = e.target.value;

    if (!/^\d*$/.test(val)) return;

    const num = Number(val);
    const maxAllowed = Math.min(walletBalance, billAmount);

    if (num > maxAllowed) {
      setAmount(maxAllowed);
      return;
    }

    setAmount(val);
  };

  return (
    <div className="ds-card p-3 sm:p-4 w-full">
      <div className="flex items-start justify-between mb-4">
        <h2 className="text-[15px] font-semibold text-[var(--text-dark)]">
          FASTag Bill Details
        </h2>

        <MdClose
          onClick={close}
          className="cursor-pointer text-[var(--text-muted)] hover:text-[var(--error-color)]"
          size={20}
        />
      </div>

      <div className="space-y-3">
        <div className="grid grid-cols-2 border-b border-[var(--border-color)] pb-2 text-[13px]">
          <span className="font-medium text-[var(--text-muted)]">Vehicle Reg No:</span>
          <span className="font-semibold text-[var(--text-dark)]">
            {bill?.bill_fetch?.cellNumber || "N/A"}
          </span>
        </div>

        <div className="grid grid-cols-2 border-b border-[var(--border-color)] pb-2 text-[13px]">
          <span className="font-medium text-[var(--text-muted)]">Customer Name:</span>
          <span className="font-semibold text-[var(--text-dark)]">
            {bill?.bill_fetch?.userName || bill?.name || "N/A"}
          </span>
        </div>

        <div className="grid grid-cols-2 border-b border-[var(--border-color)] pb-2 text-[13px]">
          <span className="font-medium text-[var(--text-muted)]">Bill Amount:</span>
          <span className="font-semibold text-[var(--error-color)]">
            ₹ {formatAmount(billAmount)}
          </span>
        </div>

        <div className="grid grid-cols-2 border-b border-[var(--border-color)] pb-2 text-[13px]">
          <span className="font-medium text-[var(--error-color)]">Due Date:</span>
          <span className="font-semibold text-[var(--text-dark)]">
            {bill?.duedate || bill?.bill_fetch?.duedate || "N/A"}
          </span>
        </div>

        <div className="mt-3">
          <label className="ds-label">
            Enter Amount <span className="text-[var(--error-color)]">*</span>
          </label>

          <input
            type="text"
            value={amount}
            onChange={handleInputChange}
            className="ds-input"
          />

          <button
            onClick={handlePayClick}
            type="button"
            disabled={loading}
            className="ds-btn ds-btn-primary ds-btn-block mt-4"
          >
            {loading ? "Processing..." : "Pay Bill"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServicesForm;
